<template>
  <div>
    <app-card v-for="(aFamily, i) in family" :family="aFamily" :key="i" />
    <add-family :modal-id="modalIdFamily" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppCard from "@/views/app/me/family/familyRow";
import AddFamily from "@/views/app/me/family/addFamily";
export default {
  name: "Display_CheckIn",
  components: {
    AppCard,
    AddFamily
  },
  created() {
    this.getFamily();
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      user: "user/profile",
      family: "user/family"
    })
  },
  data() {
    return {
      memoryCards: [],
      flippedCards: [],
      cards: cards,
      finish: false,
      start: false,
      turns: 0,
      totalTime: {
        minutes: 0,
        seconds: 0
      }
    };
  },
  methods: {
    getFamily() {
      this.$store.dispatch("user/getListFamily").then(family => {
      }).catch((rej)=>{

      });
    }
  }
};
</script>

<style lang="scss" scoped>
.resource-ico {
  cursor: pointer;
}
.price-card {
  .btn-round-fill {
    font-weight: 700 !important;
    &:hover {
      background: var(--theme-color);
    }
  }
}
.app-section {
  margin-top: 24px;
  font-family: "Nunito", sans-serif;
  font-family: "Inconsolata", monospace;
  @media (max-width: 667px) {
    .main-cards {
      justify-content: center;
      flex-direction: column-reverse;
      align-items: center;
    }
  }
  .card {
    cursor: pointer;
    background-color: #ffffff;
    // font-family: "Inconsolata", sans-serif;
    border-radius: 8px;
    border-radius: 8px;
    max-width: 256px;

    margin-bottom: 10px;
    width: 100%;
    height: 126px;
    background-repeat: no-repeat;
    filter: drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.16));
    margin-right: 24px;
    z-index: 1;
    border: none;
    position: relative;
    overflow: hidden;
    &::after {
      // background-image: url("../../assets/circlebg.svg");
      content: "";
      position: absolute;
      top: 47px;
      right: -38px;
      right: -141px;
      bottom: -50px;
      background-repeat: no-repeat;
      width: 100%;
      height: 100%;
    }
    &.active {
      background-color: var(--theme-color);
      overflow: hidden;
      .card-top {
        .del {
          cursor: pointer;
          // pointer-events: none;
        }
        .del svg path {
          fill: #fff;
          pointer-events: none;
        }
        .add {
          opacity: 1;
        }
      }
      .content {
        color: #ffffff;
      }
      .details {
        span {
          color: rgba(255, 255, 255, 0.7);
          // opacity: 0.7;
        }
      }
    }

    .card-top {
      margin-top: 17px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 25px;
      padding-right: 25px;
      .del {
        cursor: pointer;
      }
      .del svg path {
        fill: #b3c2cb;
      }
      .add {
        // fill: #fff;
        opacity: 0;
      }
    }
    .content {
      font-family: "Inconsolata", sans-serif;
      padding-left: 25px;
      font-weight: 500;
      font-size: 20px;
      font-style: normal;
      line-height: 21px;
      display: flex;
      align-items: center;
      letter-spacing: 0.05em;
      color: #474d52;
      margin-top: 13px;
      margin-bottom: 0;
    }
    .details {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 12px;
      span {
        font-family: "Inconsolata", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 17px;
        display: flex;
        align-items: center;

        color: #b3c2cb;
      }
    }
  }
  .add-card {
    width: 42px;
    height: 42px;
    background: rgba(85, 126, 251, 0.2);
    // opacity: 0.2;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    margin-bottom: auto;
    @media (max-width: 667px) {
      margin-bottom: 20px;
    }
  }
}
.form-header {
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    margin-top: 24px;

    color: #474d52;
  }
  .close {
    margin-right: 24px;
    cursor: pointer;
  }
}
.form {
  max-width: 390px;
  width: 100%;
  margin: 32px auto;
  .custom_label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    width: 100%;
    color: var(--theme-color);
  }
  .custom_input {
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 100px;
    border: none;
    outline: none;
    padding: 13px 21px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #474d52;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      font-weight: 600;
      font-size: 14px;
      color: #a1b1ba;
      margin-bottom: 8px;
    }
  }
  label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;

    /* Primary */

    color: var(--theme-color);
  }
  .w50 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    // margin-bottom: 1rem;
    // margin-top: 1rem;
  }
  .btn-round-fill {
    max-width: 381px;

    width: 100%;
    height: 48px;
    background: var(--theme-color);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px !important;
  }
  .foot {
    text-align: center;
    // margin-top: 296px;
  }
}
.accounts-nav {
  margin-top: 32px;
  // margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-family: "Nunito", sans-serif;
  flex-wrap: wrap;
  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;

    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
  }
  .status {
    margin-left: 24px;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
      span {
        color: #8d99a0;
        padding-left: 3px;
      }
    }
    .upgrade-now {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;

      display: flex;
      align-items: center;
      color: var(--theme-color);
      padding-left: 8px;
      padding-bottom: 8px;
    }
  }
  .type {
    margin-left: 36px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;

      display: flex;
      align-items: center;

      color: #8d99a0;
    }
  }
  .select-custom {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 98%;
    background-position-y: 50%;
    position: relative;
    width: 100px;
    border: none;
    font-family: "Nunito", sans-serif;
    font-family: "Nunito", sans-serif;
    font-weight: 600;
    font-style: normal;
    cursor: pointer;
    .custom_dropdown {
      list-style: none;
      font-family: "Nunito", sans-serif;
      font-weight: 600;
      font-style: normal;
      position: absolute;
      background-color: #fff;
      z-index: 99;
      margin-top: 13px;
      width: 120px;
      left: 0;
      border-radius: 5px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      height: 100px;
      // transform: translateY(10px);
      transition: 0.4s linear;
      padding: 0;
      cursor: pointer !important;
      cursor: pointer;
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 12px;
      li {
        width: 100%;
        height: 100%;
        display: flex;
        // justify-content: center;
        align-items: center;
        // border-radius: 8px;
        transition: 0.4s linear;
        &:hover span {
          color: var(--theme-color);
        }

        span {
          color: #474d52;
          text-decoration: none;
          transition: 0.4s linear;
          pointer-events: none;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .myButton {
      border: none;
      outline: none;
      background: none;
    }
    // padding-top: 0;
  }
}
.tags {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 35px;
  @media (max-width: 560px) {
    align-items: center;
    flex-direction: column;
  }
  @media (max-width: 450px) {
    margin-left: auto;
    margin-right: auto;
    // display: block;
  }
  .sortTags {
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 480px) {
      // margin-left: auto;
      flex-direction: column;
      .tag {
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }
  .tag {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    height: 35px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    background-color: #fff;
    color: #5b606c;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 32px;
    margin-right: 16px;
    &.active {
      background: rgba(85, 126, 251, 0.1);
      color: var(--theme-color);
      box-shadow: none;
    }
  }
}
.pricing-cards {
  font-family: "Nunito", sans-serif;
}

.subscription {
  display: flex;
  align-items: center;
  margin-top: 15px;
  &.report {
    width: 230px;
    margin-top: 0 !important;
  }
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #474d52;
    font-family: "Nunito", sans-serif;
    cursor: pointer;
  }
  .toggler {
    @media (max-width: 874px) {
      // margin-bottom: 10px;
      margin-left: 15px;
    }
    margin: 0 8px;
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
.overlay {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // background: ;
}
.app_details {
  margin-top: 16px;
  font-family: "Nunito", sans-serif;
  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;

    color: #474d52;
  }
  .transactions {
    margin-top: 10px;
    margin-bottom: 20px;
    @media (max-width: 420px) {
      flex-direction: column;
      align-items: center;
    }
    h5 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      display: flex;
      align-items: center;

      color: #8d99a0;
      margin: 0;
    }
    .transaction_details {
      display: flex;
      align-items: center;
      @media (max-width: 600px) {
        flex-wrap: wrap;
      }
      @media (max-width: 420px) {
        flex-direction: column;
        align-items: center;
      }
      h6 {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        display: flex;
        margin-bottom: 0;
        align-items: center;
        color: #8d99a0;
        justify-content: center;
        margin-right: 38px;
        width: 120px;
        @media (max-width: 530px) {
          margin-right: 28px;
        }
        @media (max-width: 420px) {
          margin-right: 0px;
        }
      }
      .date_btn {
        cursor: pointer;
        position: relative;
        max-width: 224px;
        width: 100%;
        height: 35px;
        background: #f3f6f9;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #474d52;
        line-height: 35px;
        &:hover {
          background: rgba(85, 126, 251, 0.1);
        }
        @media (max-width: 420px) {
          margin-bottom: 10px;
          padding: 0 10px;
        }

        .calender {
          padding-right: 12px;
        }
        .down {
          padding-left: 12px;
        }
      }
      .email_btn,
      .download_btn {
        background: rgba(85, 126, 251, 0.1);
        border-radius: 4px;
        // max-width: 87px;
        // width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        color: var(--theme-color);
        padding-left: 10px !important;
        padding-right: 10px;
        border: none;
        margin-left: 12px;
        &.download {
          max-width: 120px;
          &:hover {
            background: rgba(85, 126, 251, 0.1) !important;
          }
        }
        @media (max-width: 530px) {
          margin-left: 0px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
        span {
          padding-right: 8px;
        }
        &:focus {
          outline: none;
          border: none;
        }
      }
      .download_btn {
        // max-width: 89px;
        height: 43px;
        width: 100%;
        // justify-content: flex-start;
        background: none;
        @media (max-width: 530px) {
          margin-left: 70px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
      }
    }
  }
  .app_list {
    //max-width: 915px;
    font-family: "Nunito", sans-serif;
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    margin-top: 20px;
    filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
    border-radius: 8px;
  }
}
#deleteCard,
#subscribe {
  h3 {
    text-align: center;
    margin: 24px 0;
    margin-top: 8px;
  }
  p {
    text-align: center;
    margin-bottom: 27px;
  }
  .warning-msg {
    margin: 24px 0;
    .card-element {
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 11px;
      padding-right: 11px;
      margin-top: 5px;
      margin-bottom: 5px;
      background: #dde2e9;
      border-radius: 4px;
      border-color: transparent;
    }
    .card-errors {
      font-size: 10px;
      color: red;
    }
    p {
      text-align: center;
      margin: 0;
    }
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
}
#subscribe {
  .btn-round-fill {
    background: var(--theme-color);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px;
    color: #fff !important;
    border: none !important;
  }
  .lightFont {
    color: #b3c2cb !important;
  }
}
.price-card {
  font-family: "Nunito", sans-serif;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  background: #ffffff;
  border-radius: 8px;

  width: 100%;
  margin-bottom: 10px;

  @media (max-width: 767px) {
    margin-left: auto;
    margin-right: auto;
    // min-width: 350px;
    // min-width: 100%;
    max-width: 350px;
  }
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    margin-top: 32px;
    margin-bottom: 14px;

    color: #474d52;
  }
  .price {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    display: flex;
    align-items: center;
    text-align: center;

    margin-bottom: 18px;
    color: #474d52;
  }
  .month {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
  }
  .features {
    margin-top: 32px;
    p {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;

      display: flex;
      align-items: center;
      letter-spacing: 0.03em;

      /* Secondary */

      color: #8d99a0;
      margin-bottom: 16px;
    }
  }

  .btn-round-fill {
    max-width: 205px !important;
    width: 100%;
    height: 48px !important;
    font-style: normal;
    font-weight: normal !important;
    font-size: 16px;
    font-family: "Nunito", sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px !important;
    border: none;
    margin-bottom: 24px;
    margin-top: 32px !important;
    &.activee {
      background: rgba(85, 126, 251, 0.1) !important;
      color: var(--theme-color);
      &:hover {
        background: var(--theme-color) !important;
        color: #fff;
      }
    }
  }
}
.no-shadow {
  box-shadow: none !important;
}
.email_btn:hover {
  background-color: var(--theme-color) !important;
  background: var(--theme-color) !important;
  color: #fff !important;
  svg {
    path {
      fill: #fff !important;
    }
  }
}
</style>
